import { render, staticRenderFns } from "./ReviewInterMenu.vue?vue&type=template&id=cc21aad6&"
import script from "./ReviewInterMenu.vue?vue&type=script&lang=js&"
export * from "./ReviewInterMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReviewInterMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReviewInterMenu.vue"
export default component.exports